import { useCallback } from 'react';

import { useEffectOnce } from 'src/lib/hooks';
import { usePopups } from 'src/lib/popups';

import { CustomModelPopup } from './CustomModelPopup';

export const CUSTOM_MODEL_POPUP = Symbol('CUSTOM_MODEL');

export const useCustomModelPopup = (generationTool) => {
  const popups = usePopups();

  useEffectOnce(() => {
    popups.registerPopup(CUSTOM_MODEL_POPUP, CustomModelPopup);
  });

  return useCallback(() => {
    return new Promise((resolve) => {
      popups.openPopup(CUSTOM_MODEL_POPUP, {
        onClose: () => {
          popups.closePopup(CUSTOM_MODEL_POPUP);
          resolve(false);
        },
        onSubmit: async () => {
          popups.closePopup(CUSTOM_MODEL_POPUP);
          resolve(true);
        },
        generationTool,
      });
    });
  }, [popups, generationTool]);
};
